import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CURRENT_VERSION, ReleaseChangeType, RELEASE_NOTES } from '../shared/release-notes.data';

/**
 * "What's New" panel — reads from the single RELEASE_NOTES source of truth
 * and renders it as a scannable, newest-first changelog. Each entry can link
 * into the existing User Guide (kaveri-lite-help.html#anchor) for the "how
 * to use it" detail; this panel stays focused on *what* changed and *why*.
 */
@Component({
  selector: 'app-whats-new',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './whats-new.component.html',
  styleUrl: './whats-new.component.scss',
})
export class WhatsNewComponent {
  @Output() closed = new EventEmitter<void>();
  @Output() openGuide = new EventEmitter<string | undefined>();

  readonly currentVersion = CURRENT_VERSION;
  readonly releases = RELEASE_NOTES;

  readonly changeTypeMeta: Record<ReleaseChangeType, { icon: string; label: string }> = {
    added: { icon: 'add_circle', label: 'Added' },
    improved: { icon: 'trending_up', label: 'Improved' },
    fixed: { icon: 'build_circle', label: 'Fixed' },
  };

  close(): void {
    this.closed.emit();
  }

  onGuideLinkClick(anchor: string | undefined): void {
    this.openGuide.emit(anchor);
  }
}
